"use client";

import { TopLoadingBar } from "@/components/loading-bar";
import { Suspense } from "react";

type LoadingBarProviderProps = {
  children: React.ReactNode;
};

export function LoadingBarProvider({ children }: LoadingBarProviderProps) {
  return (
    <>
      <Suspense fallback={null}>
        <TopLoadingBar />
      </Suspense>
      {children}
    </>
  );
}
